import React from "react";
import PropTypes from "prop-types";
import STRINGS from "Constants/Strings";
import AppConstants from "Constants/AppConstants";
import AuthBody from "../Common/AuthBody/AuthBody";
import Stepper from "../Common/Stepper/Stepper";

class DebitCard extends React.Component {
  componentDidMount() {
    const { getDataFromServer } = this.props;
    window.scrollTo(0, 0);
    getDataFromServer(AppConstants.APPLICATIONSTEP.DEBIT_CARD, (response) => {
      this.setFormData(response);
    });
  }

  componentDidUpdate() {}

  setFormData = () => {};

  handleChange = (choice) => {
    const { handleChange } = this.props;
    handleChange(choice);
  };

  handleContinue = () => {
    const { handleContinue } = this.props;
    handleContinue();
  };

  handleBack = () => {
    const { handleBack } = this.props;
    handleBack(AppConstants.APPLICATIONSTEP.DEBIT_CARD);
  };

  render() {
    const { steps, activeStepID, isDebitCardEnabled } = this.props;

    const actionComponent = (
      <div className="[ debit-card-container ]">
        <Stepper
          steps={steps}
          active={activeStepID}
          defaultTitle={"DEBIT CARD"}
        />

        <div className="[ form-title ]">{STRINGS.DEBIT_CARD.TITLE}</div>

        <div className="[ form-container ]">
          <div className="[ mb-3 ]">
            <div className="[ form-label ]">
              <span
                dangerouslySetInnerHTML={{
                  __html: STRINGS.DEBIT_CARD.CHOICE_MESSAGE,
                }}
              />
            </div>

            <div className="[ row ] [ custom-radios ]">
              <div className="[ col-6 ]">
                <button
                  type="button"
                  className={
                    isDebitCardEnabled === true
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  name="choice"
                  onClick={(event) => this.handleChange(true, event)}
                >
                  {STRINGS.COMMON.CHOICE.YES}
                </button>
              </div>

              <div className="[ col-6 ]">
                <button
                  type="submit"
                  className={
                    isDebitCardEnabled === false
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  name="choice"
                  onClick={(event) => this.handleChange(false, event)}
                >
                  {STRINGS.COMMON.CHOICE.NO}
                </button>
              </div>
            </div>
            <div className="[ additional-text-container-1 ]">
              <small className="[ footnotes form-text text-muted ]">
                {STRINGS.DEBIT_CARD.DEBIT_CARD_TXT}
              </small>
            </div>
            <div className="[ additional-text-container-2 ]">
              <small className="[ footnotes form-text text-muted ]">
                {STRINGS.DEBIT_CARD.DEBIT_CARD_TXT1}
              </small>
            </div>
          </div>
        </div>

        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ]">
              <button
                type="button"
                className="[ btn  submit-btn ] [ w-100 ]"
                onClick={this.handleContinue}
              >
                {STRINGS.COMMON.CONTINUEBTN}
              </button>
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <AuthBody
        actionComponent={actionComponent}
        memberCreation
        handleBack={this.handleBack}
      />
    );
  }
}

DebitCard.propTypes = {
  getDataFromServer: PropTypes.func,
  handleContinue: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
  isDebitCardEnabled: PropTypes.bool,
};

DebitCard.defaultProps = {
  getDataFromServer: () => {},
  handleContinue: () => {},
  steps: [],
  activeStepID: -1,
  isDebitCardEnabled: false,
};

export default DebitCard;
